import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/utils/utils';
import { cva, VariantProps } from 'class-variance-authority';

const Tabs = TabsPrimitive.Root;

const tabsListVariants = cva(
    'inline-flex justify-center',
    {
        variants: {
            variant: {
                shop: 'h-12 items-start',
                editShop: 'h-12 items-start'
            }
        }
    }
);

const tabsTriggerVariants = cva(
    '',
    {
        variants: {
            variant: {
                shop: 'h-8 inline-flex flex-col justify-between items-center font-regular text-[0.875rem] text-tab-2 leading-5 border-b border-b-border-1 disabled:opacity-5 data-[state=active]:text-active data-[state=active]:after:content-[""] data-[state=active]:after:block data-[state=active]:after:w-[95%] data-[state=active]:after:h-[2px] data-[state=active]:after:bg-active data-[state=active]:after:rounded-t-sm',
                editShop: 'relative h-12 inline-flex flex-col justify-center items-center font-regular text-[0.875rem] text-active leading-5 border-b border-b-border-1 disabled:opacity-50 disabled:text-muted-foreground data-[state=active]:text-active data-[state=active]:after:content-[""] data-[state=active]:after:absolute data-[state=active]:after:bottom-0 data-[state=active]:after:block data-[state=active]:after:w-[95%] data-[state=active]:after:h-[3px] data-[state=active]:after:bg-active data-[state=active]:after:rounded-t-sm',
                scheduleList: 'h-8 font-medium text-white leading-5 disabled:opacity-5 data-[state=active]:text-white data-[state=active]:bg-active data-[state=active]:rounded'
            }
        }
    }
);

const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & VariantProps<typeof tabsListVariants>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            tabsListVariants({ variant: props.variant }),
            className
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & VariantProps<typeof tabsTriggerVariants>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            tabsTriggerVariants({ variant: props.variant }),
            className
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            className
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
